module.exports = __webpack_public_path__ + "img/all.31f1d4c6.svg";